<script>
const __ = wp.i18n.__;

import {
    onMount
} from 'svelte';
import CourseFilter from './CourseFilter.svelte';
import CourseResults from './CourseResults.svelte';
import {
    getFilteredCourses,
    createFilterUrl
} from './api';
import CourseSearchBar from './CourseSearchBar.svelte';
import {
    getApiUrl,
    setApiUrl,
    updateFilter,
    getFilter
} from './Common.svelte'
import {
    inView
} from './inView';
import Accordian from './Accordian.svelte';
    import SelectedTags from './SelectedTags.svelte';

let filteredCourses = [];
export let courseTypes = []
export let apiUrl = "";
let showFilter = true;
export let title;
export let subTitle;
export let allCategories;
export let allTags;
export let inpageFilter = true;
let hideTitle = false;
export let adminPickedCategory;
export let adminPickedTags;
export let noofitems;
export let postType;

let firstLoad = true;
//let filter = {};

// if (defaultFilter) {
//   console.log("update");
//   updateFilter(defaultFilter);
// }

async function handleFilterChange(filterUrl) {
    let f = [];
    if (!filteredCourses) {
        filteredCourses = [];
        for (let index = 0; index < 6; index++) {
            f.push({
                "loading": true
            });
        }
    }
    filteredCourses.forEach(function(v, i) {
        filteredCourses[i].loading = true;
    });
    filteredCourses = await getFilteredCourses(filterUrl);
}

async function LoadMorePosts() {
    if (!filteredCourses) {
        filteredCourses = [];
    }
    // filteredCourses.forEach(function(v, i) {
    //   filteredCourses[i].loading = true;
    // });
    
    let f = getFilter();
    f.count = parseInt(f.count) + parseInt(noofitems);
    updateFilter(f);
    let filteredCourses2 = await getFilteredCourses(createFilterUrl(getApiUrl(), f));
    filteredCourses = [];
    filteredCourses.push(...filteredCourses, ...filteredCourses2);
    filteredCourses = filteredCourses;
}

onMount(() => {
    setApiUrl(apiUrl);
    let f = [];
    for (let index = 0; index < 6; index++) {
        f.push({
            "loading": true
        });
    }
    filteredCourses = f;
    handleFilterChange(createFilterUrl(getApiUrl(), getFilter()));
    
});
let viewFilter = false;

function onFilterClick() {
    viewFilter = !viewFilter;

}

let filterButtonaActive = false;

function onFilterBtnClick() {
    viewFilter = true;
}
let handleClear;
function clearOnClick() {
    
        handleClear(); // Calls the function in the child component
    
}
</script>
<main>
    <div class="flex justify-between">
        <div class="titles">
            {#if title}
            <h2 class="text-pm-black">{title}</h2>
            {/if}
            {#if subTitle}
            <h3 class="text-pm-grey mb-4">{subTitle}</h3>
            {/if}
        </div>
        <!-- {#if showFilter} -->
        
        <!-- <div class="grid grid-cols-2 gap-2 content-center"> -->
            <!-- <a href="#" class="text-pm-pink font-semibold content-center text-center text-l" type="reset" on:click|preventDefault={clearOnClick}>{__("Clear", "frontend")}</a> -->
            
            <!-- <button on:click={onFilterBtnClick} class="flex flex-row justify-center items-center gap-2 border border-pm-pink p-3 rounded-[10px]  text-pm-pink shadow-sm {viewFilter ? "bg-pm-pink border-pm-pink text-pm-white" : ""}"> -->
            
            
            <!-- <span class="grid font-medium  course-card-filter-datalayer">Filter</span> <i class="si-round si-tune font-bold text-xl"></i></button> -->
        
        <!-- </div> -->
        <!-- {/if} -->
    </div>
</main>

<div class="container mx-auto mb-12 px-0 grid grid-rows-1 gap-5">
    <div class="lg:grid grid-cols-12 gap-5">
        <!-- <div class="col-span-12 lg:flex {viewFilter ? "show-filter" : "hidden" }">
      {#if showFilter}
      <button on:click={onFilterBtnClick} class="w-[50px] h-[50px] mx-auto justify-center items-center mb-5 flex bg-pm-white shadow-card rounded-full lg:hidden z-[1000] fixed top-[20vh] left-1/2 -translate-x-2/4"><i class="si-solid si-xmark text-2xl text-pm-pink"></i></button>
      <div class="overlay"></div>
      <CourseFilter onFilterChange={handleFilterChange} ctypes={courseTypes} />
      {/if}
        </div> -->

        <!-- <div class="col-span-12"> -->
        <div class="filter-holder col-span-12 ">
            <CourseFilter onFilterChange={handleFilterChange} ctypes={courseTypes} {allCategories} {allTags} {adminPickedCategory} {adminPickedTags} {noofitems} bind:clearTrigger={handleClear} {postType}/>
        </div>
        
        <div class="grid col-span-12 gap-5">
            
            
            
            <!-- <CourseSearchBar onFilterChange={handleFilterChange} /> -->
            <CourseResults filteredCourses={filteredCourses} />
            {#if (filteredCourses.length == 0)}
            <!-- <p class="text-center">Please change your search criteria</p>-->
            <p class="text-center">{__("Please change your search criteria", "frontend")}</p>

            {/if}
            {#if (filteredCourses.length >= 5)}

            <button class="primary-btn px-10 py-3 !w-auto justify-self-center"
                on:click={() => LoadMorePosts() }
                >{__("Load More", "frontend")}</button>
            {/if}
        </div>
        <!-- </div> -->

    </div>
</div>

<style>
.show-filter .overlay {
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
}
</style>
